import { AppState, StreamState } from '../state';

export const selectStream = (state: AppState): StreamState => state.stream;
